// extracted by mini-css-extract-plugin
module.exports = {"container":"b1ddd01198--container--Wu2FX","title-container":"b1ddd01198--title-container--htRZx","buttons":"b1ddd01198--buttons--Nq4c9"};